import { useTypedSelector } from './useTypedSelector'

export default useTypedSelector
